<template>
  <div class="footer">
    <v-footer dark color="#0026ca" padless>
      <v-container>
        <v-row>
          <v-col cols="12" sm="3" md="2">
            <div class="footer-img">
              <v-img max-width="125" src="/img/store.jpg" alt="logo"></v-img>
            </div>
          </v-col>
          <v-col cols="12" sm="3" md="3">
            <div>
              <p><strong>ALPHYIAGO STORE</strong></p>
              <p>Durban</p>
              <p>West Walk</p>
              <p>4001</p>
            </div>
          </v-col>
          <v-col cols="12" sm="4" md="4" offset-md="1">
            <div>
              <strong>CONTACT US</strong>
              <v-list
                color="#00000000"
                shaped
                v-for="snr in senior"
                :key="snr.title"
              >
                <v-list-item-group>
                  <v-list-item>
                    <v-list-item-icon>
                      <v-icon color="green">{{ snr.icon }}</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-subtitle class="font-weight-medium">{{
                        snr.title
                      }}</v-list-item-subtitle>
                      <v-list-item-title>{{ snr.value }}</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list-item-group>
              </v-list>
            </div>
          </v-col>
          <v-col cols="12" sm="2" md="2">
            <div>
              <strong>FOLLOW US</strong>
              <v-list
                color="#00000000"
                shaped
                v-for="jnr in junior"
                :key="jnr.title"
              >
                <v-list-item-group>
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-subtitle class="font-weight-medium">{{
                        jnr.title
                      }}</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </v-list-item-group>
              </v-list>
            </div>
          </v-col>
        </v-row>
      </v-container>
      <v-container>
        <v-row>
          <v-col cols="12" sm="12" md="12">
            <v-card>
              <v-card-text>
                <h3>ALPHYIAGO</h3>
                <p class="red--text">Shop with us now</p>
                <p class="font-weight-bold mb-1">Subscribe to newsletters</p>
                <p>
                  Be aware of upcoming sales and events. Receive gifts and
                  special offers!
                </p>
                <div>
                  <v-text-field
                    v-model="email"
                    name="email"
                    placeholder="Your email"
                  ></v-text-field>
                  <v-btn dark color="red" @click="subscribe"> Subscribe </v-btn>
                </div>
              </v-card-text>
              <v-card-actions>
                <VisionDialog />
              </v-card-actions>
            </v-card>
          </v-col>
          <v-col cols="12" sm="12" md="12">
            <div>
              <v-text-field
                label="Search"
                placeholder="ALPHYIAGO STORE"
                outlined
              ></v-text-field>
            </div>
          </v-col>
        </v-row>
      </v-container>
      <v-card class="flex" flat>
        <v-card-title class="connect">
          <strong class="subheading"
            >Get connected with us on social networks</strong
          >
          <v-spacer></v-spacer>
          <v-btn
            v-for="(icon, index) in icons"
            :key="index"
            class="mx-4"
            dark
            icon
          >
            <v-icon size="25px" :color="icon.color" v-text="icon.name" />
          </v-btn>
        </v-card-title>
        <v-card-text class="py-4 white--text text-center">
          Copyright
          <v-icon>mdi-copyright</v-icon>
          {{ new Date().getFullYear() }} -
          <strong>ALPHYIAGO STORE</strong>
        </v-card-text>
      </v-card>
    </v-footer>
  </div>
</template>
<script>
export default {
  data() {
    return {
      email: '',
      senior: [
        { icon: 'mdi-phone-classic', title: 'TEL', value: '+27 31-907-4351' },
        { icon: 'mdi-fax', title: 'FAX', value: '+27 31-907-1086' },
        {
          icon: 'mdi-email',
          title: 'e-Mail',
          value: 'alphyiago@gmail.com',
        },
      ],

      junior: [
        { title: 'Facebook' },
        {
          title: 'Whatsapp',
        },
        {
          title: 'Instagram',
        },
      ],
      icons: [
        { name: 'mdi-facebook', color: '#0026ca' },
        { name: 'mdi-whatsapp', color: 'green' },
        { name: 'mdi-linkedin', color: '#0026ca' },
        { name: 'mdi-instagram', color: '#833AB4' },
      ],
    }
  },
  methods: {
    subscribe() {
      this.email = ''
    },
  },
}
</script>
<style>
.footer .connect {
  background-color: #ffffff;
  color: #111214;
}
.footer .theme--dark.v-card {
  background-color: #111214;
  color: #ffffff;
}
.footer .v-list-item {
  padding: 0;
}
.footer .contact-value {
  font-size: 15px;
}
</style>